import { useId } from 'react';
import { Defs, LinearGradient, Path, Stop } from 'react-native-svg';
import Svg from 'react-native-svg';
import { TIllustrationProps } from '@/common/components/Illustrations/types';

export const IconCoverflex = ({
  width = 133,
  height = 21,
  className,
  color,
}: TIllustrationProps) => {
  const id = useId();
  return (
    <Svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 133 21"
      fill="none"
    >
      <Path
        fill={color ?? `url(#coverflex-logo-a-${id})`}
        fillRule="evenodd"
        d="M25.87 20.14a14 14 0 0 0-3.29-8.36A12.5 12.5 0 0 0 4.3 10.72 13.92 13.92 0 0 0 0 20.14h25.87Z"
        clipRule="evenodd"
      />
      <Path
        fill={color ?? '#051D2E'}
        d="M108.3 11.05c.29-.82.7-1.54 1.23-2.16a5.76 5.76 0 0 1 2-1.47 6.18 6.18 0 0 1 5.77.37 6.26 6.26 0 0 1 2.18 2.45 7.23 7.23 0 0 1 .7 4.38h-9.27c.18.8.57 1.45 1.17 1.93.6.49 1.33.73 2.22.73.58 0 1.14-.12 1.67-.36.54-.23.97-.6 1.31-1.06l2.15 1.8a5.73 5.73 0 0 1-2.18 1.93c-.91.46-1.89.7-2.93.7a6.4 6.4 0 0 1-6.47-6.65c0-.9.15-1.77.44-2.59Zm8.78 1.13c-.09-.65-.42-1.2-.98-1.63a3.15 3.15 0 0 0-1.99-.66 3 3 0 0 0-1.91.62 3.4 3.4 0 0 0-1.18 1.67h6.06Z"
      />
      <Path
        fill={color ?? '#051D2E'}
        d="m124.33 13.47-3.91-6.36h3.4l2.24 3.45 2.22-3.45h3.4l-3.94 6.36 4.35 6.46h-3.37l-2.66-4.1-2.67 4.1h-3.38l4.32-6.46ZM106.56 17.15c-.52 0-.87-.12-1.05-.34-.19-.23-.28-.58-.28-1.06V.54h-3.15V16.5c0 1.21.31 2.15.93 2.8.62.66 1.51.98 2.67.98.4 0 .85-.07 1.36-.22v-2.94c-.11.02-.28.03-.48.03ZM34.03 8.82a6.1 6.1 0 0 1 4.57-1.95 6.5 6.5 0 0 1 5.45 3.04l-2.69 1.65a3.4 3.4 0 0 0-1.18-1.1c-.49-.28-1.01-.41-1.58-.41-.91 0-1.7.35-2.37 1.04-.66.7-.99 1.53-.99 2.47 0 .95.33 1.8 1 2.49.66.7 1.45 1.05 2.36 1.05.6 0 1.14-.15 1.64-.44.5-.3.9-.7 1.2-1.21l2.66 1.67a6.55 6.55 0 0 1-2.32 2.3 6.22 6.22 0 0 1-6.42-.04 6.84 6.84 0 0 1-3.2-5.82c0-1.86.62-3.44 1.87-4.74ZM46.82 8.82a6.1 6.1 0 0 1 4.57-1.95A6.38 6.38 0 0 1 57 10.19c.57 1.03.85 2.15.85 3.37a6.81 6.81 0 0 1-3.2 5.82c-1 .6-2.09.9-3.27.9-1.19 0-2.26-.3-3.25-.9a6.84 6.84 0 0 1-3.2-5.82c0-1.86.63-3.44 1.88-4.74Zm2.2 7.23c.66.7 1.45 1.05 2.37 1.05.92 0 1.73-.35 2.38-1.05.66-.7 1-1.53 1-2.49 0-.95-.34-1.77-1-2.47a3.16 3.16 0 0 0-2.38-1.05c-.93 0-1.7.35-2.37 1.05-.66.7-1 1.52-1 2.47 0 .95.34 1.79 1 2.49ZM61.22 7.1l3.1 8.7 3.12-8.7h3.43l-4.9 12.83h-3.29l-4.9-12.82h3.44ZM71.16 11.05c.3-.82.71-1.54 1.25-2.16a5.76 5.76 0 0 1 1.99-1.47 6.18 6.18 0 0 1 5.77.37 6.26 6.26 0 0 1 2.19 2.45 7.23 7.23 0 0 1 .7 4.38h-9.28c.19.8.58 1.45 1.17 1.93.6.49 1.34.73 2.22.73.58 0 1.14-.12 1.67-.36.54-.23.98-.6 1.32-1.06l2.15 1.8a5.73 5.73 0 0 1-2.2 1.93c-.9.46-1.87.7-2.92.7a6.4 6.4 0 0 1-6.47-6.65c0-.9.15-1.77.44-2.59Zm8.8 1.13c-.1-.65-.42-1.2-1-1.63a3.15 3.15 0 0 0-1.98-.66 3 3 0 0 0-1.91.62 3.4 3.4 0 0 0-1.18 1.67h6.07ZM88 6.86v1.2a5 5 0 0 1 1.87-.94c.67-.17 1.6-.25 2.8-.25v3.18c-.8 0-1.47.04-2.03.14a4.9 4.9 0 0 0-1.36.4 2 2 0 0 0-.8.71c-.2.3-.32.61-.39.94-.07.33-.1.73-.1 1.2v6.5l-3.15-.01V6.86H88ZM100.38 3.65V.54a22.52 22.52 0 0 0-2.87.02h-.14a3.2 3.2 0 0 0-2.2 1.08 4.62 4.62 0 0 0-.92 3.06v15.23h3.15v-9.88h2.98V7.1H97.4V5.18c0-1.85 1.83-1.55 2.98-1.53Z"
      />
      <Defs>
        <LinearGradient
          id={`coverflex-logo-a-${id}`}
          x1="0"
          x2="10.31"
          y1="7.24"
          y2="27.9"
          gradientUnits="userSpaceOnUse"
        >
          <Stop offset="0" stopColor="#FE7165" />
          <Stop offset="1" stopColor="#FF8D78" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
};
